<template>
  <div>
    <br>
    <v-container fluid grid-list-md>
      <v-layout row wrap class="pt-5 mt-2" >
        <v-flex xs12 sm8 offset-sm2 md4 offset-md4>
          <v-card style="position: relative" class="text-xs-center">
            <br><br><br>
            <v-img 
              :src="require('../assets/images/company_logo.png')"
              width="150" 
              height="auto"
              style="margin: 0 auto;"></v-img>
            <v-card-title>
              <v-flex xs12>
                  <h2 class="grey--text text--darken-2">Welcome to Yatri</h2>
              </v-flex>

              <v-flex xs12>
                <br>
                <v-form @submit.prevent="validateBeforeSubmit" width="100%" class="login_form">
                  <p v-if="validationErrors.length > 0"> 
                    <span v-for="error in validationErrors" style="color: red">{{ error }}</span>
                  </p>
                  <v-text-field  
                    v-model="email" 
                    label="Email" 
                    name="email"
                    browser-autocomplete=off 
                    required
                   >
                   </v-text-field>
                  <v-text-field
                    v-model="password"
                    :type="e1 ? 'password' : 'text'"
                    name="Password"
                    label="Password"
                    browser-autocomplete=off
                    required
                  >
                  <template  v-slot:append>
                    <v-icon style="cursor: pointer;" @mousedown="mouseOver" @mouseup="mouseLeave" v-if="e1">visibility</v-icon>
                    <v-icon style="cursor: pointer;" @mousedown="mouseOver" @mouseup="mouseLeave" v-else>visibility_off</v-icon>
                  </template>
                  </v-text-field>
                  
                  <v-btn
                    type="submit"
                    class="primary white--text"
                    :loading="is_loading"
                    :disabled="is_loading"
                  >Login</v-btn>
                  <br>
                  <br>
                  <!-- <p>The portal can be viewed in Google Chrome browser</p> -->
                </v-form>
              </v-flex>
              <v-alert :value="true" outline color="error" icon="warning" v-if="error" id="alert-flex">{{ error }}</v-alert>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  created() {},
  methods: {
    login() {
      this.is_loading = true;
        let user_data =[this.email,this.password];
        var key = 'a2qT8wXZkL8YTsXT';
        var CryptoJS = require("crypto-js");
        var AES = require("crypto-js/aes");
        var CryptoJSAesJson = {
          stringify: function (cipherParams) {
              var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
              if (cipherParams.iv) j.iv = cipherParams.iv.toString();
              if (cipherParams.salt) j.s = cipherParams.salt.toString();
              return JSON.stringify(j).replace(/\s/g, '');
          },
          parse: function (jsonStr) {
              var j = JSON.parse(jsonStr);
              var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
              if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
              if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
              return cipherParams;
          }
      }
        var data = CryptoJS.AES.encrypt(JSON.stringify(user_data), key, {format: CryptoJSAesJson}).toString();
        let headers = {
          'app-type': 'yatri-web',
          'api-key' : process.env.VUE_APP_API_KEY
        };

      axios
        .post(`${process.env.VUE_APP_API_URL}/api/v1/login`, {data:data},{headers})
        .then(response => {
          if (response.data.status == 1) {
            const user = response.data.user || {};
            const roles = Array.isArray(user.roles) ? user.roles : [];
            const userRole = roles.length ? roles[0].name : '';

            this.$store.dispatch('storeAccessToken', response.data.access_token);
            this.$store.dispatch('storeUser', user)
              .then(() => {
                let json_permission = JSON.stringify(response.data.permissions || []);
                localStorage.setItem("access_token", response.data.access_token);
                localStorage.setItem("expiration", response.data.expiration);
                localStorage.setItem("permissions", json_permission);
                localStorage.setItem("auth_user", JSON.stringify(user));
                this.$store.dispatch('storePermissions', json_permission)
                  .then(() => {
                  this.$parent.$emit('permissions-fetched');
                })
                  // axios.defaults.headers.common['app-type'] = 'web';
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.get_access_token;

                if(userRole == 'marketing')
                {
                  // this.$router.push('/announcements');
                  window.location.href = '/announcements';
                }
                else if(userRole == 'data_user'){
                  // this.$router.push('/localTrains');
                  window.location.href = '/localTrains';
                }else if(userRole == 'wa_announcer'){
                  // this.$router.push('/trip-announcements');
                  window.location.href = '/trip-announcements';
                }else if(userRole == 'customer_support'){
                  // this.$router.push('/feedbackList');
                  window.location.href = '/feedbackList';
                }else if(userRole == 'customer_support_manager'){
                  // this.$router.push('/');
                  window.location.href = '/';
                }else if(userRole == 'user_engagement'){
                  // this.$router.push('/trip-announcements');
                  window.location.href = '/trip-announcements';
                }else if(userRole == 'cr_cpro_user'){
                  // this.$router.push('/announcements');
                  window.location.href = '/announcements';
                }else if(userRole == 'cr_controlroom_user'){
                  // this.$router.push('/trip-announcements');
                  window.location.href = '/trip-announcements';
                }else if(userRole == 'account'){
                  window.location.href = '/ondc-settlement';
                } else {
                  window.location.href = '/';
                  // this.$router.push('/');
                }
                
              });
          }else if(response.data.status == 0){
            this.error = response.data.message;
          }
          else {
            this.error = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },

    validateBeforeSubmit: function(e) {
      e.preventDefault();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validationErrors = [];
          if (this.email == '') {
            this.validationErrors.push('Employee Code is required.');
          }else if(this.password == ''){
             this.validationErrors.push('Password is required.');
          }else{
             this.login();
          }
         
        }
        return false;
      });
    },
    mouseOver(){
    this.e1 = false;
  },
    mouseLeave(){
   this.e1 = true;
    //mousedown, mouseup and mouseleave 
  }
 
  },
 
  data() {
    return {
      e1: true,
      is_loading: false,
      email: "",
      password: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      error: this.$route.query.error,
      validationErrors: [],
      formErrors: {}
    };
  },
  mounted() {
    if(localStorage.getItem('access_token') !== null) {
    }
  }
};
</script>
<style>
body {
  background: #ecf1f4;
}
</style>
